module.exports = __webpack_public_path__ + "img/ammiraglio 9 bagno.1f1236f1.jpeg";